// extracted by mini-css-extract-plugin
module.exports = {"Content":"Home_Content__2fLoy","ContentHeader":"Home_ContentHeader__N6prC","BioContainer":"Home_BioContainer__2A03Q","ImgContainer":"Home_ImgContainer__1gLOe"};